import { useSortable } from '@dnd-kit/react/sortable'
import {
  CheckIcon,
  DotsSixVerticalIcon,
  PencilSimpleIcon,
  TrashIcon,
  XIcon,
} from '@phosphor-icons/react'

import { Button } from '../button'
import { Icon } from '../icon'
import { TextInput } from '../text-input'
import * as S from './editable-list.styled'
import { SortableRowProps } from './editable-list.types'

export const SortableRow = ({
  item,
  index,
  isThisRowEditing,
  isAnyRowEditing,
  inputValue,
  inputError,
  isConfirmDisabled,
  maxLength,
  onEditStart,
  onDeleteClick,
  onInputChange,
  onInputCancel,
  onInputConfirm,
}: SortableRowProps) => {
  const { ref } = useSortable({ id: `editable-list-${item.id}`, index })

  return (
    <S.Row ref={ref}>
      <S.DragHandle $disabled={isAnyRowEditing}>
        <Icon icon={DotsSixVerticalIcon} />
      </S.DragHandle>

      {isThisRowEditing ? (
        <>
          <S.InputWrapper>
            <TextInput
              autoFocus
              size="medium"
              value={inputValue}
              error={inputError}
              maxLength={maxLength}
              onChange={(e) => onInputChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onInputConfirm()
                if (e.key === 'Escape') onInputCancel()
              }}
            />
          </S.InputWrapper>
          <S.Actions>
            <Button onlyBox use="ghost" size="small" onClick={onInputCancel}>
              <Icon icon={XIcon} color="red500" />
            </Button>
            <Button
              onlyBox
              use="ghost"
              size="small"
              disabled={isConfirmDisabled}
              onClick={onInputConfirm}
            >
              <Icon icon={CheckIcon} color="green500" />
            </Button>
          </S.Actions>
        </>
      ) : (
        <>
          <S.ItemName>{item.name}</S.ItemName>
          <S.Actions>
            <Button
              onlyBox
              use="ghost"
              size="small"
              disabled={isAnyRowEditing}
              onClick={onEditStart}
            >
              <Icon icon={PencilSimpleIcon} />
            </Button>
            <Button
              onlyBox
              use="ghost"
              size="small"
              disabled={isAnyRowEditing}
              onClick={onDeleteClick}
            >
              <Icon icon={TrashIcon} color="red500" />
            </Button>
          </S.Actions>
        </>
      )}
    </S.Row>
  )
}
